import { CanDeactivateFn } from "@angular/router";
import type { OfflineSync } from "./offline-sync";

/**
 * Prevents leaving the offline sync page while the queued transactions are being replayed.
 *
 * The in-app Back button is disabled, but the browser back/forward buttons and the Android hardware back button navigate
 * through the router as well, so routing this check through `CanDeactivate` covers all of them.
 */
export const offlineSyncCanDeactivateGuard: CanDeactivateFn<OfflineSync> = component => component.canDeactivate();
